export default {
    'Geographic zone': 'Geographic zone',
    'Unknown': 'Unknown',
    'bandwith_explanation': 'These rates correspond to the reception and sending of <strong>short segments</strong>, identical to those of a live streaming stream. <strong>This data does not correspond to the speed of your internet line</strong> but to the ability to read a streaming stream from the vodalys.io platform on a given workstation and according to the <strong>current use of your internet line</strong>.',
}
